import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ISummaryBlocksConfiguration } from '../models';
import { IFactProps } from '@kurtosys/ksys-app-components/dist/components/fact/Fact/models/IFactProps';
import { IFactQueries } from '@kurtosys/ksys-app-components/dist/models/IFactQueries';

interface IFactsQueryResult {
	dataPoints: IFactProps[];
}

export class SummaryBlocksStore extends StoreBase {
	static componentKey: 'summaryBlocks' = 'summaryBlocks';

	@computed
	get configuration(): ISummaryBlocksConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(SummaryBlocksStore.componentKey);
		}
	}

	@computed
	get dataPoints(): IFactQueries[] {
		return (this.configuration && this.configuration.dataPoints) || [];
	}

	@computed
	get facts(): IFactProps[] {
		const componentOrchestration = {
			queries: { dataPoints: this.dataPoints },
			props: {},
		};
		const facts: IFactsQueryResult | undefined = this.mergeQueriesAndProps(componentOrchestration);
		return (facts && facts.dataPoints) || [];
	}

	@action
	async initialize(): Promise<void> {}
}
